const isExternalElement = (element) => {
    return element.tag === 'external';
};
const isInput = (element) => {
    return element.tag === 'input';
};
const isDateInput = (element) => {
    return element.tag === 'dateInput';
};
const isSelect = (element) => {
    return element.tag === 'select';
};
const isDatePicker = (element) => {
    return element.tag === 'datePicker';
};
const isTextarea = (element) => {
    return element.tag === 'textarea';
};
const isInputSearchDropdown = (element) => {
    return element.tag === 'inputSearchDropdown';
};
const isValidations = (item) => {
    return !!item.schema;
};

export { isDateInput, isDatePicker, isExternalElement, isInput, isInputSearchDropdown, isSelect, isTextarea, isValidations };
//# sourceMappingURL=typeGuards.js.map
